// tslint:disable
/**
 * LXBackend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime';
/**
 * 
 * @export
 * @interface ClassroomThreadCreate
 */
export interface ClassroomThreadCreate {
    /**
     * 
     * @type {string}
     * @memberof ClassroomThreadCreate
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof ClassroomThreadCreate
     */
    subCategory: string;
    /**
     * 
     * @type {string}
     * @memberof ClassroomThreadCreate
     */
    content: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ClassroomThreadCreate
     */
    freeFormTags?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ClassroomThreadCreate
     */
    classroom: string;
}

export function ClassroomThreadCreateFromJSON(json: any): ClassroomThreadCreate {
    return {
        'title': json['title'],
        'subCategory': json['sub_category'],
        'content': json['content'],
        'freeFormTags': !exists(json, 'free_form_tags') ? undefined : json['free_form_tags'],
        'classroom': json['classroom'],
    };
}

export function ClassroomThreadCreateToJSON(value?: ClassroomThreadCreate): any {
    if (value === undefined) {
        return undefined;
    }
    return {
        'title': value.title,
        'sub_category': value.subCategory,
        'content': value.content,
        'free_form_tags': value.freeFormTags,
        'classroom': value.classroom,
    };
}


